export default __webpack_public_path__ + "static/media/Montserrat-Bold.4beb3ff6.eot";